import { LaunchFile } from './loadLaunchFilesStrategy';
import {
  ConnectionStrategy,
  ResponseMessage,
  SSHMessage,
  WebsocketSSHConnection
} from './robotConnection';

export class RunRobotCommandStrategy implements ConnectionStrategy {
  runningLaunchFiles: LaunchFile[] = [];
  messageStack: SSHMessage[] = [];
  sourceString: string;
  constructor(sourceString: string) {
    this.sourceString = sourceString;
  }
  processMessage(
    connection: WebsocketSSHConnection,
    message: ResponseMessage
  ): void {
    if (message.error && message.error.isError) {
      console.log(`Run error: ${message.error.errorMsg}`);
    }
    const nextMsg = this.messageStack.shift();
    if (nextMsg) {
      connection.sendMessage(nextMsg.toMessage());
    }
  }
  /**
   * creates a new tmux session called miros if none exists
   * @returns
   */
  getFirstMessage(): SSHMessage | null {
    return new SSHMessage('tmux ls | grep miros || tmux new -s miros -d');
  }
  /**
   * adds message to stack, gets
   * @param msg
   */
  addMsgToStack(msg: SSHMessage) {
    this.messageStack.push(msg);
  }

  getLaunchFileName(launchFile: LaunchFile): string {
    if (launchFile.name.includes('.'))
      return launchFile.name.slice(0, launchFile.name.indexOf('.'));
    return launchFile.name;
  }

  getStartLaunchFileMsg(launchFile: LaunchFile): SSHMessage {
    return new SSHMessage(
      `tmux new-window -t miros: -n:${this.getLaunchFileName(launchFile)} '${
        this.sourceString
      } ros2 launch ${launchFile.pkgName} ${launchFile.name}'`
    );
  }

  getStopLaunchFileMsg(launchFile: LaunchFile): SSHMessage {
    return new SSHMessage(
      this.getKillTmuxWindowMsgString(this.getLaunchFileName(launchFile))
    );
  }

  getKillTmuxWindowMsgString(windowName: string): string {
    return `CMD_OUTPUT=\`tmux list-windows -t miros: | grep ${windowName}\` ; IFS=: ; set - $CMD_OUTPUT ; tmux send-keys -t miros:$1 C-c`;
  }
  /**
   * creates new tmux window for the specified command, with the specified window name
   * if the window already exists kills the window then relaunches
   * @param command
   * @param windowName
   * @returns
   */
  getStartRosMsg(command: string, windowName: string): SSHMessage {
    return new SSHMessage(
      `tmux list-windows -t miros | grep ${windowName} && (${this.getKillTmuxWindowMsgString(
        windowName
      )}) ; tmux new-window -t miros: -n:${windowName} '${
        this.sourceString
      } ${command}'`
    );
  }
  setRunningLaunchFiles(launchFiles: LaunchFile[]) {
    this.runningLaunchFiles = launchFiles;
  }
}
